import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  newTowingOrderButton: { id: 'towingJobs.heading.button.new.towingOrder', defaultMessage: '+ Towing order' },
  newTowingRecordButton: { id: 'towingJobs.heading.button.new.towingRecord', defaultMessage: '+ Towing record' },
  noTowingJobs: { id: 'towingJobs.noTowingJobs', defaultMessage: 'No towing orders or records' },
  filterActiveBanner: { id: 'towingJobs.filterActiveBanner', defaultMessage: 'Tuloksia on suodatettu' },
  heading: { id: 'towingJobs.heading', defaultMessage: 'Työlista' },
  completedHeading: { id: 'towingJobs.completedHeading', defaultMessage: 'Valmiit työt' },
  newSosButton: { id: 'towingJobs.heading.button.new.sos', defaultMessage: '+ Uusi SOS' },
  refreshUpdate: { id: 'towingJobs.refresh.update', defaultMessage: 'Päivitä' },
  refreshUpdating: { id: 'towingJobs.refresh.updating', defaultMessage: 'Päivitetään' },
  changeToTowing: { id: 'towingJobs.changeToTowing', defaultMessage: 'Jos työ muuttuu hinaukseksi:' },
  paymentLinkSent: { id: 'towingJobs.paymentLinkSent', defaultMessage: 'maksulinkki lähetetty' },
})
